/**
 * @description Component-TokenPairSimple
 */
import { TokenInfo } from '@/types/token';
import './index.less';

import { WrappedBigNumber } from '@/entities/WrappedBigNumber';
import { Side } from '@synfutures/sdks-perp';
import { FC } from 'react';
import TokenPairLeverage from '../TokenPairLeverage';
import TokenPairSymbol from '../TokenPairSymbol';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
  baseToken: TokenInfo;
  quoteToken: TokenInfo;
  isInverse?: boolean;
  leverage?: WrappedBigNumber;
  tradeSide?: Side;
}
const TokenPairSimple: FC<IPropTypes> = function ({ baseToken, quoteToken, isInverse, tradeSide, leverage }) {
  return (
    <div className="syn-token-pair-simple">
      {!!tradeSide && <div className={`syn-token-pair-simple-side ${Side[tradeSide]?.toLowerCase()}`} />}
      <TokenPairSymbol requiredMarginIcon={false} baseToken={baseToken} quoteToken={quoteToken} isInverse={isInverse} />
      {leverage?.gt(0) && <TokenPairLeverage leverage={leverage} tag={true} />}
    </div>
  );
};

export default TokenPairSimple;
